// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"88e1339e","225":"d94e4fc0","362":"fe05d219","551":"f6acab65","673":"cf7908ec","714":"f987c9dd","853":"4a454acc","934":"ce225b80","987":"81436b07"}[chunkId] + ".chunk.css";
};